export * from './EndGameHeaderInfo.tsx';
